// Libs
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cx from 'classnames';
import useTranslator from 'UTILS/hooks/useTranslator';

// Components
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import SettingsIcon from '@material-ui/icons/Settings';
import Box from '@material-ui/core/Box';

// Actions
import { leaveClick } from 'REDUCERS/navSlice';

// Utils
import { useTheme } from '@material-ui/core/styles';
import { NARROW_LAYOUT } from 'UTILS/constants';
import { onTrackedClick } from 'UTILS/callbacks';
import translations from './locales.json';

const BottomHeader = () => {
  const dispatch = useDispatch();
  const [translate] = useTranslator(translations);
  const theme = useTheme();
  const isSmallScreen = useSelector(state => state.app.layout === NARROW_LAYOUT);
  const shouldShowBackButton = useSelector(state => state.app.backUrl || state.app.closeOnBack);

  const handleBackClick = () => {
    onTrackedClick('back', 'header');
    dispatch(leaveClick());
  };

  const classes = cx('bottomHeader-container', {
    'bottomHeader-container_darkAndOneLine': !isSmallScreen,
  });

  const styles = isSmallScreen ? {} : { background: `linear-gradient(90deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.dark} 100%)` };

  return (
    <div
      style={styles}
      className={classes}
    >
      {shouldShowBackButton && (
        <div className='bottomHeader-backButton'>
          <Button variant='text' color='primary' onClick={handleBackClick}
            startIcon={isSmallScreen ? (
              <ArrowBackIcon color='primary' />
            ) : (
              <ArrowBackIosIcon fontSize='small' htmlColor={theme.palette.secondary.contrastText} />
            )}
          >
            <Box
              color={!isSmallScreen ? theme.palette.secondary.contrastText : null}>{isSmallScreen ? translate('backToSpace') : translate('back')}</Box>
          </Button>
        </div>
      )}
      <div className='bottomHeader-info'>
        {!isSmallScreen && (
          <SettingsIcon fontSize='large' htmlColor={theme.palette.secondary.contrastText} className='bottomHeader-settingsIcon' />
        )}
        <Typography variant={isSmallScreen ? 'body1' : 'h6'}>
          <Box component='span' color={!isSmallScreen ? theme.palette.secondary.contrastText : null} >{translate('testMyHardware')}</Box>
        </Typography>
      </div>
    </div>
  );
};

export default BottomHeader;
